import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import CompanyAttachmentUploadForm from "../forms/company-attachment-upload-form.js";
import CompanyLosServices from "../services/company-los-services";
import { Map, List } from "immutable";


class CompanyAttachmentUploadModal extends Component {
    formRef = React.createRef();
    onFormSubmit = () => {
        if(!this.props.formSubmitting) {
            this.formRef.current.validateFields((err, values) => {
                if(!err) {
                    this.props.onSubmit({
                        documentId: values.document_id,
                        file: values.file,
                        remarks: values.remarks
                    });
                }
            });
        }
    }
    onCancel = () => {
        if(!this.props.formSubmitting) {
            this.props.onClose();
        }
    }
    componentDidMount() {
        CompanyLosServices.fetchDocumentMasterList().then(response => {
            if(response.data) {
                this.docMasterList = List(response.data || []).filter(_ => ![8,7,6,12,13].includes(_.id))
                    .groupBy((_) => _ && _.document_category && _.document_category.name)
                    .filter((_) => _.size > 0)
                    .map((options) =>
                        options
                            .map((__) => ({
                                key: __.id,
                                value: String(__.id),
                                label: __.document_name,
                                rest: { label: __.document_name }
                            }))
                            .toArray()
                    );
                this.forceUpdate();
            }
            return [];
        });
    }
    render() {
        return(
            <Modal  
                afterClose={() => this.formRef.current.resetFields()}
                visible={this.props.isVisible}
                closeable={!this.props.formSubmitting}
                onOk={this.onFormSubmit}
                onCancel={this.onCancel}
                okText={"Submit"}
                confirmLoading={this.props.formSubmitting}
            >
                <CompanyAttachmentUploadForm 
                    ref={this.formRef} 
                    values={Map(this.props.values)} 
                    docMasterGroups={this.docMasterList || Map({})}
                />
            </Modal>
        );
    }
}

CompanyAttachmentUploadModal.propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    formSubmitting: PropTypes.bool,
    onSubmit: PropTypes.string,
    values: PropTypes.object
};

CompanyAttachmentUploadModal.defaultProps = {
    formSubmitting: false
};

export default CompanyAttachmentUploadModal;